export default "__VITE_ASSET__BlrJzpjo__"